import { create } from 'zustand'

/**
 * Shared UI state for the bid Knowledge view. The `KnowledgeView` (search + upload) and the
 * `SourceInspector` (right column) are rendered as siblings by `App`, so the current query and
 * the selected source live in this small store rather than being threaded through props.
 *
 * Only UI state lives here — the source data itself is server state fetched with TanStack Query
 * (keyed by `['knowledge', bid, submittedQuery]`), never mirrored into the store.
 */
interface KnowledgeStore {
  /** The live search-box text (updates on every keystroke). */
  query: string
  /** The query that was actually submitted — drives the `/v1/ask` retrieval query. */
  submittedQuery: string
  /** The source the user selected in the results table, previewed by the inspector. */
  selectedSourceId: string | null
  setQuery: (q: string) => void
  submit: () => void
  select: (id: string | null) => void
  reset: () => void
}

export const useKnowledgeStore = create<KnowledgeStore>((set, get) => ({
  query: '',
  submittedQuery: '',
  selectedSourceId: null,
  setQuery: (q) => set({ query: q }),
  submit: () => set({ submittedQuery: get().query.trim(), selectedSourceId: null }),
  select: (id) => set({ selectedSourceId: id }),
  reset: () => set({ query: '', submittedQuery: '', selectedSourceId: null }),
}))
